import React, { Component } from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import withMobileDialog from "@material-ui/core/withMobileDialog";
import {EmptyRecord} from "../../utils/PageUtility";
import RecordPagination  from "../../utils/RecordsPagination";
import Edit from "@material-ui/icons/Edit";

import {
    Table,
    TableHead,
    TableCell,
    TableRow,
    TableBody,
} from "@material-ui/core";

import Tooltip from '@material-ui/core/Tooltip';

const CustomTableCell = withStyles(theme => ({
    head: {
        color: " #66bb6a",
        fontSize: "14px",
        fontWeight: "lighter"
    },
    icon:{
        margin: "8px",
        position: "relative",
        top: "7px",
        paddingLeft: "8px",
    },
    body: {
        fontSize: 14
    }
}))(TableCell);

const styles = {
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0"
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF"
        }
    },
    icon:{
        margin: "8px 0px 8px 8px",
        position: "relative",
        top: "7px",
        paddingLeft: "8px",
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Poppins', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1"
        }
    },
    tableStyle: {
        padding: 0
    }
};

const TableStructure = ({ pageIndex, filterAirport, classes, pageSize, currentPage, records, handleEdit,filterNotificationType, filterAirline}) => {

    return (
    <Table className={classes.table} aria-labelledby="tableTitle">
        <TableHead color="success">
            <TableRow>
                <CustomTableCell>S/N</CustomTableCell>
                <CustomTableCell>Airline</CustomTableCell>
                <CustomTableCell>Airport</CustomTableCell>
                <CustomTableCell>Emails</CustomTableCell>
                <CustomTableCell>Mobile Numbers</CustomTableCell>
                <CustomTableCell>Notification Type</CustomTableCell>
                <CustomTableCell>Action</CustomTableCell>
            </TableRow>
        </TableHead>
        <TableBody>
            {records && records.ResultList.map((n, i) => {
                return (
                    <TableRow
                        hover
                        // onClick={event => this.handleClick(event, n.id)}
                        // tabIndex={-1}
                        key={i}
                    >
                        <CustomTableCell style={{maxWidth:"300px"}}>
                            {pageIndex + i}
                        </CustomTableCell>
                        <CustomTableCell component="th">
                            <div>{filterAirline(n.AirlineId) }</div>
                        </CustomTableCell>
                        <CustomTableCell component="th">
                            <div>{filterAirport(n.AirportCode) }</div>
                        </CustomTableCell>
                        <CustomTableCell style={{ wordBreak: 'break-all', maxWidth:"15%"}}>
                            <div> {n.Email}</div>
                        </CustomTableCell>
                        <CustomTableCell style={{ wordBreak: 'break-all', maxWidth:"15%"}}>
                            <div> {n.MobileNo}</div>
                        </CustomTableCell>
                        <CustomTableCell>
                            <div> {filterNotificationType(n.NotificationTypeId)}</div>
                        </CustomTableCell>
                        <CustomTableCell>
                            <span
                                style={{ cursor: "pointer", color: "#dd2735" }}
                                onClick={()=>handleEdit(n)}
                            >
                                <Tooltip title="Edit" placement="top">
                                    <span> <Edit/></span>
                                </Tooltip>
                            </span>
                        </CustomTableCell>
                    </TableRow>
                );
            })}
        </TableBody>
    </Table>
    )
};

class EmailTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            flight: false,
            airlines:[],
        };
    }
    handleClickOpen = (flight) => {
        this.setState({ open: true });
        this.setState({flight});
        this.props.fetchFlightPassengers(flight.Id);
    };

    handleClose = () => {
        this.setState({ open: false });
    };


    render() {
        const { classes, totalCounts,fetchRecords,filterNotificationType, filterAirline, handleEdit, filterUsers, currentPage,airlinesData,notificationType, pageSize, user, records, filterAirport } = this.props;
        const pageIndex = (pageSize * (currentPage - 1)) + 1;

        if(totalCounts === 0)
            return (<EmptyRecord message={'No Email Notifications Yet!'}/>);

        return (
            <div>
                <div className={classes.tableResponsive} style={{ overflowX: "auto" }}>
                    <RecordPagination fetchMore={fetchRecords} totalCount={totalCounts} pageSize={pageSize} currentPage={currentPage} target={<TableStructure  pageIndex={pageIndex} filterAirport= {filterAirport} pageSize={pageSize} currentPage = {currentPage} filterNotificationType={filterNotificationType} filterAirline={filterAirline} notificationType={notificationType} airlinesData={airlinesData}  records={records} classes={classes} filterUsers={filterUsers} handleEdit={handleEdit}  user={user} />}/>
                </div>
            </div>
        );
    }
}

export default withMobileDialog()(withStyles(styles)(EmailTable));



// WEBPACK FOOTER //
// ./src/views/EmailSettings/emailTable.js